module.exports = __webpack_public_path__ + "img/attention.c5b77de7.svg";